module.exports = __webpack_public_path__ + "img/EXIST.40ea3046.svg";